var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.902,
    height: 21.902,
    viewBox: "0 0 28.902 21.902",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7691",
    "data-name": "Path 7691",
    d: "M4262.822,999.536q-4.126,0-8.25,0a3.47,3.47,0,0,1-3.507-3.48q-.01-6.97,0-13.941a3.474,3.474,0,0,1,3.509-3.479q8.251,0,16.5,0a3.284,3.284,0,0,1,2.9,1.54c1.155,1.79,2.268,3.608,3.4,5.415.355.569.727,1.129,1.061,1.71a3.306,3.306,0,0,1,0,3.566c-1.44,2.361-2.914,4.7-4.393,7.04a3.379,3.379,0,0,1-3.022,1.627Q4266.92,999.54,4262.822,999.536Zm-.012-1.73q4.1,0,8.2,0a1.76,1.76,0,0,0,1.6-.858q2.181-3.481,4.351-6.969a1.614,1.614,0,0,0,0-1.783q-2.177-3.516-4.382-7.014a1.7,1.7,0,0,0-1.535-.821h-16.389a1.751,1.751,0,0,0-1.86,1.855q0,6.847,0,13.694a1.754,1.754,0,0,0,1.9,1.891Z",
    transform: "translate(-4250.564 -978.135)",
    fill: "#394f65",
    stroke: "#394f65",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagIcon);
export default __webpack_public_path__ + "static/media/tag-icon.f0ff3201349bcfee94057bd187d14123.svg";
export { ForwardRef as ReactComponent };